import { render, staticRenderFns } from "./DetailConsignment.vue?vue&type=template&id=a9281764&scoped=true&"
import script from "./DetailConsignment.vue?vue&type=script&lang=js&"
export * from "./DetailConsignment.vue?vue&type=script&lang=js&"
import style0 from "./DetailConsignment.vue?vue&type=style&index=0&id=a9281764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9281764",
  null
  
)

export default component.exports